module.exports = __webpack_public_path__ + "img/del.12575b9f.svg";